import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CommonCommunicationService {
  constructor() { }
  private moduleList$: BehaviorSubject<any> = new BehaviorSubject(null);
  userLoginData$: BehaviorSubject<any> = new BehaviorSubject(null);
  activeShopId$: BehaviorSubject<any> = new BehaviorSubject(null);
  jwtToken: any

  setModuleList(acc: boolean) {
    this.moduleList$.next(acc);
  }

  getModuleList(): Observable<boolean> {
    return this.moduleList$.asObservable();
  }

  getUserData(): Observable<any> {
    return this.userLoginData$.asObservable();
  }

  setUserData(data: any) {
    this.userLoginData$.next(data);
  }

  getActiveShopId(): Observable<any> {
    return this.activeShopId$.asObservable();
  }

  setActiveShopId(data: any) {
    this.activeShopId$.next(data);
  }

  setJwtToken(acc: any) {
    this.jwtToken = acc
  }

  getJwtToken() {
    return this.jwtToken
  }
}